// extracted by mini-css-extract-plugin
export default {"gen-ai__list":"GenAIPage_gen-ai__list__XlNpQ"};